/* origen-co.js — ¿DE QUÉ ANUNCIO VINO ESTE CLIENTE? (Capa 3 de data/agentes/ESTRATEGIA-ATRIBUCION-CO.md)
 *
 * Aprobado por el dueño el 01-oct (id `dueno-20261001-sbcol-decisiones-2`). Antes de esto el
 * formulario COD de Colombia producía CERO pedidos atribuibles a una campaña (septiembre:
 * 135 → 0 con id de campaña), porque el cliente llega a la ficha con `?utm_…&ang=…&fbclid=…`,
 * navega, agrega al carrito y el formulario se abre en OTRA URL donde esos parámetros ya no están.
 *
 * Qué hace, y nada más:
 *   · en CADA carga mira la URL; si trae `ang`, `utm_*` o `fbclid`, los guarda en localStorage
 *     junto con la página de entrada. Guarda la PRIMERA visita con parámetros (no se pisa) y
 *     la ÚLTIMA (se actualiza). Caduca a los 30 días.
 *   · expone `window.CcoOrigen.leer()` → `{ primera, ultima }` o `null`, para que el formulario
 *     COD (cod-co.js) y el carrito (/checkout-flash-co) lo manden al servidor, que lo limpia y
 *     lo escribe como customAttributes ocultos «_…» (src/cod-co/origen-co.js).
 *
 * 🔒 NO TOCA EL DOM, NO LLAMA A LA RED, NO PONE TIMERS, NO LEE NADA PERSONAL. Sólo guarda lo que
 * la propia URL del anuncio ya traía. Si localStorage no existe (modo privado, bloqueado) cae a
 * una variable en memoria: sólo vale para esa carga, y el formulario sigue funcionando igual.
 * 🔒 Idempotente: se puede incluir dos veces (layout del tema y snippet del formulario).
 * ES5 a propósito (mismo criterio que el resto de los assets de este tema).
 */
(function () {
  'use strict';
  if (window.CcoOrigen) return;

  var CLAVE = 'cco_origen_v1';
  var TTL_MS = 30 * 24 * 3600 * 1000;
  var PARAMS = ['ang', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid'];
  var MAX = 255;
  var enMemoria = null;

  function limpio(v) {
    if (v == null) return '';
    return String(v).replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/^\s+|\s+$/g, '').slice(0, MAX);
  }

  // `URLSearchParams` existe en todo navegador que usa un cliente colombiano de hoy, pero se
  // parsea a mano igual: un `decodeURIComponent` mal formado no debe poder romper la ficha.
  function paramsDe(search) {
    var out = {};
    var q = String(search || '').replace(/^\?/, '');
    if (!q) return out;
    var partes = q.split('&');
    for (var i = 0; i < partes.length; i++) {
      var kv = partes[i].split('=');
      var k = '';
      try { k = decodeURIComponent(kv[0] || '').toLowerCase(); } catch (e) { k = ''; }
      if (PARAMS.indexOf(k) < 0) continue;
      var v = '';
      try { v = decodeURIComponent((kv.slice(1).join('=') || '').replace(/\+/g, ' ')); } catch (e2) { v = kv.slice(1).join('='); }
      v = limpio(v);
      if (v && !out.hasOwnProperty(k)) out[k] = v;   // el primero de la URL manda
    }
    return out;
  }

  function toca(params, pathname) {
    var o = {};
    var hay = false;
    for (var i = 0; i < PARAMS.length; i++) {
      var k = PARAMS[i];
      if (params[k]) { o[k] = params[k]; hay = true; }
    }
    if (!hay) return null;
    var p = String(pathname || '');
    if (p.charAt(0) === '/') o.landing = p.split(/[?#]/)[0].slice(0, 150);
    o.ts = Date.now();
    return o;
  }

  function leerCrudo() {
    var txt = null;
    try { txt = window.localStorage.getItem(CLAVE); } catch (e) { txt = null; }
    var o = null;
    if (txt) { try { o = JSON.parse(txt); } catch (e2) { o = null; } }
    if (!o || typeof o !== 'object') o = enMemoria;
    if (!o || typeof o !== 'object') return null;
    var ahora = Date.now();
    var salida = {};
    var k2 = ['primera', 'ultima'];
    for (var i = 0; i < k2.length; i++) {
      var t = o[k2[i]];
      if (t && typeof t === 'object' && typeof t.ts === 'number' && ahora - t.ts < TTL_MS) salida[k2[i]] = t;
    }
    return (salida.primera || salida.ultima) ? salida : null;
  }

  function guardar(o) {
    enMemoria = o;
    try { window.localStorage.setItem(CLAVE, JSON.stringify(o)); } catch (e) { /* sin storage: sólo memoria */ }
  }

  function capturar() {
    var t = null;
    try { t = toca(paramsDe(window.location.search), window.location.pathname); } catch (e) { t = null; }
    if (!t) return;
    var previo = leerCrudo() || {};
    guardar({ primera: previo.primera || t, ultima: t });
  }

  // Lo que viaja al servidor: sin `ts` (es de uso interno de la caducidad) y con las claves
  // que el servidor acepta. Nunca lanza.
  function leer() {
    try {
      var o = leerCrudo();
      if (!o) return null;
      var salida = {};
      var k2 = ['primera', 'ultima'];
      for (var i = 0; i < k2.length; i++) {
        var t = o[k2[i]];
        if (!t) continue;
        var c = {};
        var n = 0;
        for (var j = 0; j < PARAMS.length; j++) { if (t[PARAMS[j]]) { c[PARAMS[j]] = limpio(t[PARAMS[j]]); n++; } }
        if (t.landing) c.landing = limpio(t.landing);
        if (n) salida[k2[i]] = c;
      }
      return (salida.primera || salida.ultima) ? salida : null;
    } catch (e) { return null; }
  }

  window.CcoOrigen = { capturar: capturar, leer: leer };
  capturar();
})();
